import {
  Component,
  OnInit,
} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {OrderBagService} from "../services/orderbag/orderbag.service";
import {TranslateService} from "ng2-translate";
import {DEFAULT_VIDEO_CALL_URL} from "../services/constants";
import {WedomeetService} from "../services/wedomeet/wedomeet.service";
import {VideoCallService} from "../services/video-call/video-call.service";
import {MeetingVM} from "../models/MeetingVM.model";
import {MeetingUserVM} from "../models/MeetingUserVM.model";
import {ServantService} from "../services/servant-service/servant-service";
import {ServantVM} from "../models/ServiceItemDetailVM";
import {PaymentResultVM} from "../models/PaymentResultVM.model";
import {AlertService} from "../services/alert/alert.service";
import {DateUtilService} from "../services/date-service/DateUtilService";
import {CompanyService} from "../services/company-service/company-service";
import {CompanyVM} from "../models/CompanyVM.model";
import {VideoCallSettingInfoVM} from "../models/VideoCallSettingInfoVM.model";
import {InvoiceInfoService} from "../services/invoice-info-service/invoice-info.service";
import {InvoiceInfoVM} from "../models/InvoiceInfoVM.model";

@Component({
  selector: 'invoice-info-detail',
  template: require('./invoice-info-detail.component.html'),
  providers: [InvoiceInfoService,OrderBagService,ServantService],
  styles: [require('./invoice-info-detail.component.css')]

})
export class InvoiceInfoDetailComponent implements OnInit {


  public invoiceInfo:InvoiceInfoVM;
  public order_detail_id;
  public isModerator =false ;
  company: CompanyVM;
  public pageTitle:string= '';


  constructor(private activatedRoute: ActivatedRoute,
              private orderBagService: OrderBagService,
              private invoiceInfoService: InvoiceInfoService,
              private translate: TranslateService,
              private alertService:AlertService,
              private companyService: CompanyService,
  ) {

    translate.setDefaultLang('fa');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('fa');
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {

      this.getInvoiceInfo(+params['invoiceInfoId']);

    });


    this.companyService.getCompanyInfo().subscribe((c: CompanyVM) => {
      this.company = c;
    });



  }

  public getInvoiceInfo(id) {
    let parent = this;
    parent.invoiceInfoService.getInvoiceInfoById(id).subscribe(detail => {
      parent.invoiceInfo = detail;
      this.setPageTitle();
    })
  }

  public setPageTitle() {
    let title = "فاکتور" + " : " + this.invoiceInfo.id ;
    this.pageTitle = title;
  }


}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/invoice-info-detail/invoice-info-detail.component.ts